export default "__VITE_ASSET__BaOHtSUn__"